import { useI18n } from '@/i18n';
import { Button } from '@/components/ui/button';
import { Check, CreditCard, Loader2 } from 'lucide-react';

export function BookingActionButton({ property, nights, deposit, appliedCoupon, onPayment, processingPayment, bookingRequestStatus }) {
  const { t, formatPrice, currency } = useI18n();

  if (!property.price_min_usd) return null;

  return (
    <>
      <Button
        className="w-full bg-[#264639] hover:bg-[#1C352B] py-6 text-lg mb-3"
        onClick={onPayment}
        disabled={processingPayment || nights <= 0 || bookingRequestStatus === 'pending'}
        data-testid="request-booking-btn"
      >
        {processingPayment ? (
          <>
            <Loader2 className="w-5 h-5 mr-2 animate-spin" />
            Enviando solicitud...
          </>
        ) : bookingRequestStatus === 'pending' ? (
          <>
            <Check className="w-5 h-5 mr-2" />
            Solicitud enviada
          </>
        ) : (
          <>
            <CreditCard className="w-5 h-5 mr-2" />
            {nights > 0 ? `Reservar ${formatPrice(appliedCoupon ? appliedCoupon.final_deposit : deposit)}` : t('detail.selectDates')}
          </>
        )}
      </Button>

      {/* Currency notice for PYG */}
      {currency === 'PYG' && nights > 0 && (
        <p className="text-xs text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/30 rounded-lg px-3 py-2 mb-3" data-testid="pyg-notice">
          El cobro se realizara en USD al tipo de cambio oficial. El monto apróximado en PYG es referencial.
        </p>
      )}
    </>
  );
}
